import {useState, useMemo} from "react";
import {
    ClearColor, NavItem, NavWrapper,
    RecordsSummary,
    StatsTable, StatsWrap,
    TableCell,
    TableHeader,
    TableRow,
    Wrapper
} from "../styled";

export const YearsStats = ({statistics = []}) => {
    const yearStats = useMemo(() => {
        return statistics
            .filter(stat => stat?.item?.title?.match(/^\d{4}$/))
            .sort((a, b) => b.item.title.localeCompare(a.item.title));
    }, [statistics]);

    const years = yearStats.map(stat => stat.item.title);
    const [activeYear, setActiveYear] = useState(years[0] || '');

    const currentYearData = useMemo(() => {
        const activeStat = yearStats.find(stat => stat.item.title === activeYear);
        if (!activeStat?.item?.records) return null;

        const records = activeStat.item.records;
        const columns = records.columns || [];
        const rows = records.rows || [];

        return {
            recordTitle: records.record_title || '',
            recordCount: records.record_count || 0,
            columns,
            rows
        };
    }, [yearStats, activeYear]);

    if (yearStats.length === 0 || !currentYearData) {
        return null;
    }

    const getColumnValue = (row, columnId) => {
        if (columnId === 'name' || columnId === 'category') {
            return row[columnId] || row.name || row.category || '';
        }
        return row[columnId] !== null && row[columnId] !== undefined ? row[columnId] : '';
    };

    const formatValue = (value, column) => {
        if (value === null || value === undefined || value === '') return '';
        if (column.type === 'number') {
            const numValue = typeof value === 'number' ? value : parseFloat(value);
            if (isNaN(numValue)) return value;
            if (column.id === 'percentage') {
                return numValue === 100 ? '100%' : `${numValue.toFixed(1)}%`;
            }
            return numValue.toFixed(1);
        }
        return value;
    };

    const formatDisclosed = (value) => {
        if (value === null || value === undefined || value === '') return '';
        return `(${value})`;
    };

    return (
        <Wrapper>
            <NavWrapper>
                {years.map((year) => (
                    <NavItem
                        key={year}
                        active={year === activeYear}
                        onClick={() => setActiveYear(year)}
                    >
                        {year}
                    </NavItem>
                ))}
            </NavWrapper>

            <RecordsSummary>
                {currentYearData.recordTitle}
                <ClearColor>{currentYearData.recordCount}</ClearColor>
            </RecordsSummary>

            <StatsWrap>
                <StatsTable>
                    <thead>
                        <TableHeader>
                            {currentYearData.columns.map((column) => (
                                <TableCell key={column.id} as="th" align={column.id === 'percentage' || column.id === 'disclosed' ? 'right' : 'left'}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableHeader>
                    </thead>
                    <tbody>
                        {currentYearData.rows.map((row, index) => (
                            <TableRow key={index}>
                                {currentYearData.columns.map((column) => {
                                    const value = getColumnValue(row, column.id);
                                    const isNameColumn = column.id === 'name' || column.id === 'category';

                                    return (
                                        <TableCell
                                            key={column.id}
                                            indented={row.indent > 0}
                                            align={column.id === 'percentage' || column.id === 'disclosed' ? 'right' : 'left'}
                                        >
                                            {isNameColumn
                                                ? value
                                                : column.id === 'disclosed'
                                                    ? formatDisclosed(value)
                                                    : formatValue(value, column)
                                            }
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                    </tbody>
                </StatsTable>
            </StatsWrap>
        </Wrapper>
    );
};

